export const PARTNER_LEGAL_LINKS = {
    termsOfService: 'https://www.houzy.ch/business/agb',
    dataPolicy: 'https://www.houzy.ch/datenschutzbestimmungen',
};
export const CURRENT_PARTNER_TOS_VERSION = '2026-09-15';
export const CURRENT_CONSUMER_PLATFORM_TOS_VERSION = '2026-09-15';
